import produce from "immer";
import moment from "moment";
import {
  ActionType,
  ClearSelectedBookingAction,
  SelectBookingAction,
  SetFiltersAction,
  SetSortOptionsAction,
} from "checkouts/actions";
import { CHECKOUTS_SAVED_FILTERS } from "core/constants";
import { GetInquiryCheckoutsConnectionsInquiry } from "core/queries/GetInquiryCheckouts";
import {
  InquiryCheckoutSortColumn,
  InquiryCheckoutStatus,
  SortAscDesc,
} from "typings/globalGQLTypes";

export type AllCheckoutsActions =
  | SelectBookingAction
  | ClearSelectedBookingAction
  | SetFiltersAction
  | SetSortOptionsAction;

export interface CheckoutsFilterInput {
  checkoutStatuses: InquiryCheckoutStatus[];
}

export interface CheckoutsState {
  booking: GetInquiryCheckoutsConnectionsInquiry | null;
  filters: CheckoutsFilterInput;
  sort: CheckoutsSortInput[];
}

export interface CheckoutsSortInput {
  column: InquiryCheckoutSortColumn;
  order: SortAscDesc;
}

const saveFilters = (filters: CheckoutsFilterInput) => {
  localStorage.setItem(CHECKOUTS_SAVED_FILTERS, JSON.stringify(filters));
};

const initialSort = [
  {
    column: InquiryCheckoutSortColumn.unit_internal_ref,
    order: SortAscDesc.asc,
  },
  {
    column: InquiryCheckoutSortColumn.check_out_time,
    order: SortAscDesc.desc,
  },
];

export const initialState: CheckoutsState = {
  booking: null,
  filters: {
    checkoutStatuses: [InquiryCheckoutStatus.not_checked_out],
  },
  sort: initialSort,
};

export const savedFilterState = {
  ...initialState,
  filters: {
    ...initialState.filters,
    ...JSON.parse(localStorage.getItem(CHECKOUTS_SAVED_FILTERS) || "{}"),
  },
};

export const getCheckoutDateRange = (date = moment()) => ({
  endAt: date.clone().endOf("day"),
  startAt: date.clone().startOf("day"),
});

export const checkoutsReducer = (
  state = savedFilterState,
  action: AllCheckoutsActions,
) =>
  produce(state, draft => {
    switch (action.type) {
      case ActionType.SetSortOptions: {
        draft.sort = action.payload;
        return draft;
      }
      case ActionType.ClearSelectedBooking: {
        draft.booking = null;
        return draft;
      }
      case ActionType.SelectBooking: {
        draft.booking = action.payload;
        return draft;
      }

      case ActionType.SetFilters: {
        draft.filters = {
          ...draft.filters,
          ...action.payload,
        };
        saveFilters(draft.filters);
        return draft;
      }

      default:
        return draft;
    }
  });
